import React, { useContext } from 'react' 
import slugify from 'react-slugify';  
import { reportData } from '../../../../data/report-data/report-data/reportData';
import { LangContext, MenuContext } from '../../../../context/DataContext';

function MenuLateralInvestigacionAtaquesDdos() {
    const { myLang } = useContext(LangContext);
    const { activeAnchor, scrollToAnchor } = useContext(MenuContext);

    const currentMenu = reportData.investigacionAtaquesDdos[myLang];

    if (!currentMenu) return null;

    return (
        <nav>
            <button>
                {currentMenu.title}
                <i className="fas fa-angle-down"></i>
            </button>
            <ul className="active">
                {currentMenu.items.map(({ id, label }) => (
                    <li key={id}>
                        <a
                            href={`#${slugify(label)}`}
                            className={activeAnchor === id ? 'active' : null}
                            onClick={() => scrollToAnchor(id)}
                        >
                            {label}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default MenuLateralInvestigacionAtaquesDdos